import { render, staticRenderFns } from "./InterviewItem.vue?vue&type=template&id=495a8a7a&"
import script from "./InterviewItem.vue?vue&type=script&lang=ts&"
export * from "./InterviewItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports